module.exports = __webpack_public_path__ + "img/Upload-excel.536b5f66.svg";